import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import '../styles/AchievementAnimation.css';

interface AchievementAnimationProps {
  habitId: string;
  date: string;
}

const AchievementAnimation: React.FC<AchievementAnimationProps> = ({ habitId, date }) => {
  const [show, setShow] = useState(true);
  const { language } = useTranslation();

  const messages = language === 'ja' ? [
    '素晴らしい！🎉',
    'よくできました！👏',
    'その調子！💪',
    '継続は力なり！🌟',
    'ナイス！👍',
    'グッジョブ！✨',
    'お見事！🎯',
    'すごい！🔥'
  ] : [
    'Awesome! 🎉',
    'Well done! 👏',
    'Keep it up! 💪',
    'Persistence is power! 🌟',
    'Nice! 👍',
    'Good job! ✨',
    'Excellent! 🎯',
    'Amazing! 🔥'
  ];

  // マウント時に1回だけランダムインデックスを決定する（useRefで保持）
  // 再レンダリングのたびにMath.random()を呼ぶと、親の再レンダリング中に
  // アニメーション表示中のメッセージが変わってしまうバグを防ぐ
  const randomIndexRef = useRef(Math.floor(Math.random() * messages.length));
  const randomMessage = messages[randomIndexRef.current] ?? messages[0];
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, 2500);
    
    return () => clearTimeout(timer);
  }, []);
  
  if (!show) return null;
  
  return (
    <div className="achievement-overlay">
      <div className="achievement-animation">
        <div className="achievement-content">
          <div className="achievement-icon">✓</div>
          <div className="achievement-message">{randomMessage}</div>
          <div className="achievement-sparkles">
            <span className="sparkle">✨</span>
            <span className="sparkle">✨</span>
            <span className="sparkle">✨</span>
            <span className="sparkle">✨</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementAnimation;